// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selected: null,
  states: []  
}

const provider_questions = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA':
      return { ...state, allData: action.data }
    case 'GET_PROVIDER_QUESTIONS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'DELETE_PROVIDER_QUESTION':
      return { ...state }
    case 'GET_PROVIDER_QUESTION':
      return { ...state, selected: action.selected }
    case 'GET_STATES':
      return { ...state, states: action.states }
    case 'EDIT_PROVIDER_QUESTION':
      return { ...state }
    default:
      return { ...state }
  }
}
export default provider_questions
